export enum HttpErrorCodes {
	INCORRECT_EMAIL_PIN = '2_PARTY_422_1',
	MAX_OTP_GENERATION_LIMIT_REACHED = '0_ONBOARD_422_104',
	MAX_OTP_VERIFICATION_LIMIT_REACHED = '0_ONBOARD_422_502',
	CUSTOMER_OUTOFBAND_OTP = '0_ONBOARD_422_106',
	BUSINESS_ERROR = '1_SBBONBOARDING_400_1',
	TECHNICAL_ISSUE = '1_SBBONBOARDING_500_1',
	INVALID_REQUEST = '2_ONBOARDINGBFFSBB_400_1',
	CUSTOMER_WITH_EMAIL_ALREADY_EXISTS = '2_PARTY_409_1',
	QUEBEC_RESTRICTION = '2_PARTY_400_1',
	AGE_OF_MAJORITY = '2_PARTY_400_10',
	PARTY_BUSINESS_EXISTS = '2_PARTY_400_8',
	INVALID_BUSINESS_REGISTRY = '2_PARTY_400_4',
	DUPLICATE_SIN = '2_PARTY_400_5',
	PARTY_NOT_FOUND = '2_PARTY_404_4',
	CREDENTIALS_CREATION_FAILURE = '0_3_5_0',
	INVALID_PASSWORD_CREATION = '0_EQAUTH_422_113'
}
